import { Button, DialogActions } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Localization from 'l18n/l18n';
import * as React from 'react';

function CalendarSettinsDialog(props) {
 
  let { handleClose: onClose, open, children } = props;
  const childRef = React.useRef();

 

  const handleCance = () => {
    onClose();
  };

  const handleCancel = React.useCallback(handleCance,[]);

  const handleSave = () => {
    childRef.current.save() ;
    onClose(open);
  };

  children = {
    ...children,
    props: {
      ...children.props,
      handleCancel,
    },
    ref:childRef
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%' } }}
      maxWidth="sm"
      open={open}
 
    >
      {children}
      <DialogActions>
        <Button
          autoFocus
          variant="contained"
          sx={{
            width: '100%',
            boxShadow: 'none',
            borderRadius: 0,
            color: '#FFFFFF',
          }}
          onClick={handleSave}
        >
          {Localization.translate['save']}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default React.memo(CalendarSettinsDialog);
